import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/arpit/dev/gatsby-theme-candor/theme/src/templates/Page.tsx";
import { Styled, css, Image } from "theme-ui";
import { Link } from "gatsby";
import animTvSignalNoisy from "../images/anim-tv-signal-noisy@md.gif";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "gatsby-theme-candor-demo"
    }}>{`Gatsby Theme Candor (Demo)`}</h1>
    <Image src={animTvSignalNoisy} mdxType="Image" />
    <p>{`Gatsby Theme Candor is a simple and honest theme that will help you set up a production-grade website in no time.`}</p>
    <p>{`Out of the box, it provides support for Typescript, MDX, and a custom theme built using the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`theme-ui`}</code>{` spec.
It also comes pre-configured to support a blog, frontmatter, syntax highlighting in code blocks, and responsive images.`}</p>
    <h2 {...{
      "id": "preview"
    }}>{`Preview`}</h2>
    <p>{`Go to the `}<a parentName="p" {...{
        "href": "/gatsby-theme-candor/theme-preview"
      }}>{`Theme Preview`}</a>{` page to see the theme in action!`}</p>
    <p>{`Go to the `}<a parentName="p" {...{
        "href": "/gatsby-theme-candor/blog"
      }}>{`Blog Index`}</a>{` page to quickly find a list of all the pages in the demo site.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <ol>
      <li parentName="ol">{`Install the theme`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i --save @shetharp/gatsby-theme-candor
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# or`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`yarn`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span>{` @shetharp/gatsby-theme-candor`}</code></pre></div>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Add the theme to your `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`gatsby-config.js`}</code>{` files`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// gatsby-config.js`}</span>{`

module`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`exports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"@shetharp/gatsby-theme-candor"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Create `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.mdx`}</code>{` files on your `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/pages`}</code>{` and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/posts`}</code>{` folders and you are all set.`}</li>
    </ol>
    {
      /* prettier-ignore-start */
    }
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "mdx"
    }}><pre parentName="div" {...{
        "className": "language-mdx"
      }}><code parentName="pre" {...{
          "className": "language-mdx"
        }}>{`// pages/index.mdx

---
title: Hello World! This is a frontmatter title.
author: Arlo Medi
date: 2020-07-30
---

# Hello World!

Lorem ipsum dolor sit amet.`}</code></pre></div>
    {
      /* prettier-ignore-end */
    }
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <p>{`This Gatsby theme lets you easily set up a website with pages and blog posts from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.mdx`}</code>{` files.`}</p>
    <ul>
      <li parentName="ul">{`Pages are sourced from the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/pages`}</code>{` directory`}</li>
      <li parentName="ul">{`Posts are sourced from the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/posts`}</code>{` directory`}</li>
      <li parentName="ul">{`This is made possible with the `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-source-filesystem/"
        }}>{`gatsby-source-filesystem`}</a>{`,
`}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-page-creator/"
        }}>{`gatsby-plugin-page-creator`}</a>{`, and
`}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-mdx/"
        }}>{`gatsby-plugin-mdx`}</a>{` plugins`}</li>
    </ul>
    <p>{`This theme also supports the following out of the box:`}</p>
    <ul>
      <li parentName="ul">{`Frontmatter querying and referencing from your MDX files`}</li>
      <li parentName="ul">{`Syntax highlighting in your MDX code blocks with `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-remark-prismjs/"
        }}>{`gatsby-remark-prismjs`}</a></li>
      <li parentName="ul">{`Responsive optimized images with `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-remark-images/"
        }}>{`gatsby-remark-images`}</a>{` and `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-sharp/"
        }}>{`gatsby-plugin-sharp`}</a></li>
      <li parentName="ul">{`Theming with `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-theme-ui/"
        }}>{`gatsby-plugin-theme-ui`}</a></li>
      <li parentName="ul">{`Type-checking with Typescript`}</li>
    </ul>
    <p><em parentName="p">{`Learn more about how this theme was developed: `}<a parentName="em" {...{
          "href": "#!"
        }}>{`TODO`}</a></em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      